import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { STORAGE_KEYS } from "@shared/constants/storageKeys";
import { getProjectsWithAssignments } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Obtiene los proyectos con asignaciones y los persiste en localStorage para
// que los selectores de dialogs puedan leerlos de forma sincrónica.
export const useProjectAssignments = () => {
  const query = useQuery({
    queryKey: timeEntryKeys.projectsWithAssignments(),
    queryFn: getProjectsWithAssignments,
  });

  // Sincroniza localStorage cada vez que el backend devuelve datos frescos.
  useEffect(() => {
    if (query.data) {
      localStorage.setItem(STORAGE_KEYS.PROJECT_ASSIGNMENTS, JSON.stringify(query.data));
    }
  }, [query.data]);

  return query;
};
